import familiadosApiClient from '$utils/familiadosApiClient'
import { CustomerPersonalData, Profile } from '$domain/model/customer/customer.model'
import { apiErrorService } from '$utils/services/apiErrorService'
import { modelToPersonalDataForm, customerPersonalDataToModel } from '$domain/model/customer/customer.mapper'

export const postCustomerPersonalDataPath = '/customer/save-personal-data'
export const getCustomerPersonalDataPath = '/customer/personal-data'
export const getProfilePath = '/customer/profile-data'
export const registerCustomerPath = 'customer/register'
export const registerGuestCustomerPath = 'customer/register/guest'
export const registerLoginCustomerPath = '/customer/register_and_login'

export const registerCustomer = async (name: string, phone: string, email: string, password: string) => {
  try {
    return await familiadosApiClient.post<{ id: string }>(registerCustomerPath, {
      name,
      phone,
      email,
      password,
    })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const sendCustomerPersonalData = async (personalData: CustomerPersonalData) => {
  try {
    const customerPersonalDataModelValues = customerPersonalDataToModel(personalData)
    await familiadosApiClient.post(postCustomerPersonalDataPath, customerPersonalDataModelValues)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getCustomerPersonalData = async () => {
  try {
    const retrievedCustomerData = await familiadosApiClient.get<CustomerPersonalData>(getCustomerPersonalDataPath)
    return modelToPersonalDataForm(retrievedCustomerData)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getProfile = async () => {
  try {
    return await familiadosApiClient.get<Profile>(getProfilePath)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const registerAndLoginCustomer = async registerLoginInfo => {
  try {
    return await familiadosApiClient.post<{
      token: string
      groups: [string]
      id: string
    }>(registerLoginCustomerPath, { ...registerLoginInfo })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const registerGuestCustomer = async (email: string, password: string) => {
  try {
    await familiadosApiClient.post(registerGuestCustomerPath, {
      email,
      password,
    })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/customer/customer.manager.ts